import React, {Component} from 'react';

import ReactHighcharts from 'react-highcharts';
import funnel from 'highcharts/modules/funnel';

(funnel)(ReactHighcharts.Highcharts);

export default class PyramidChart extends Component {

    _getGraphConfig = () => {
        return {
            chart: {
                type: 'column',
                height: 220,
                width: 200
            },
            title: {
                text: ''
            },
            xAxis: {
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                categories: [
                    'Comportamiento últimos 6 trimestres ',
                ],
                labels: {
                    enabled: true
                }
            },
            yAxis: {
                gridLineWidth: 0,
                minorGridLineWidth: 0,
                min: 0,
                labels:{
                    enabled:false},
                title: {
                    text: ''
                },
                stackLabels: {
                    enabled: true,
                    style: {
                        color: 'gray'
                    }
                }
            },
            legend: {
                enabled:false,
            },
            tooltip: {
                labels:{
                    enabled:false},
                pointFormat: '<tr><td style="color:{series.color};padding:0"><b>{series.name}: </b></td>' +
                '<td style="padding:0"><b>{point.percentage:,.0f}%</b></td></tr>'
            },
            plotOptions: {
                series: {
                    stacking: 'percent',
                    dataLabels: {
                        enabled: true,
                        format: ' <b>{point.percentage:,.0f}%',
                        color: 'white',
                        softConnector: false
                    },
                    labels: {
                        enabled: true,
                    },
                    center: ['40%', '50%'],
                    width: 200,
                    height: 170,
                    colors: this.props.colors
                }
            },
            credits:{
                enabled:false
            },
            series: this.props.data
        };
    };


    render() {

        let graph_config = this._getGraphConfig();

        return (
            <div style={{marginTop:15}}>
                <ReactHighcharts config={graph_config}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/pyramidPerSegment/components/pyramidChart/PyramidChart.js